import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Empty, Skeleton, Tabs } from 'antd';

import { CustomTabs, Tab } from './styles';
import { useRosaContext } from '../../../context';
import { CategorySection } from './CategorySection';
import { useGetRosaCategories } from '../../../hooks/useGetRosaCategories';

export function Elements() {
	const { organization_id, company_id } = useRosaContext();

	const { isLoading, data, isError } = useGetRosaCategories({
		organization_id,
		company_id
	});

	if (isLoading) {
		return <Skeleton active />;
	}

	if (isError) {
		return <Empty />;
	}

	const items = data.map((category) => {
		return {
			key: category.id,
			label: category.description,
			children: <CategorySection category={category} />
		};
	});

	function renderTabs(props: any): JSX.Element {
		const totalPanes = items.length;

		return (
			<CustomTabs>
				{items?.map(({ key, label }) => {
					return (
						<Tab
							key={key}
							span={24 / totalPanes}
							$isSelected={props.activeKey === key}
							onClick={(e) => props.onTabClick(key, e)}
						>
							{I18n.get(label)}
						</Tab>
					);
				})}
			</CustomTabs>
		);
	}

	return (
		<Row>
			<Col span={24}>
				<Tabs type="card" items={items} renderTabBar={renderTabs} />
			</Col>
		</Row>
	);
}
